import { render, staticRenderFns } from "./eduContinueChangForm.vue?vue&type=template&id=1354efb6&"
import script from "./eduContinueChangForm.vue?vue&type=script&lang=js&"
export * from "./eduContinueChangForm.vue?vue&type=script&lang=js&"
import style0 from "./eduContinueChangForm.vue?vue&type=style&index=0&id=1354efb6&prod&lang=less&"
import style1 from "./eduContinueChangForm.vue?vue&type=style&index=1&id=1354efb6&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports